<template>
<div class="chapter">
<div class="inner_page">
<p><a id="fm1"></a></p>
<div class="fmhT"><b>ALSO BY HENNING MANKELL</b></div>
<div class="fmtx1">FICTION</div>
<div> <br/></div><div class="fmtx1"><i>Faceless Killers</i></div>
<div class="fmtx1"><i>The White Lioness</i></div>
<div class="fmtx1"><i>The Dogs of Riga</i></div>
<div class="fmtx1"><i>The Man Who Smiled</i></div>
<div class="fmtx1"><i>Sidetracked</i></div>
<div class="fmtx1"><i>The Fifth Woman</i></div>
<div class="fmtx1"><i>One Step Behind</i></div>
<div class="fmtx1"><i>Firewall</i></div>
<div class="fmtx1"><i>The Return of the Dancing Master</i></div>
<div class="fmtx1"><i>Before the Frost</i></div>
<div class="fmtx1"><i>Chronicler of the Winds</i></div>
<div class="fmtx1"><i>Depths</i></div>
<div class="fmtx1"><i>Kennedy’s Brain</i></div>
<div class="fmtx1"><i>The Eye of the Leopard</i></div>
<div> <br/></div><div class="fmtx1">NONFICTION</div>
<div> <br/></div><div class="fmtx1"><i>I Die, But My Memory Lives On</i></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// henn_9781595585820_oeb_fm1_r1.vue?0701603a